<template>
  <v-dialog :value="open" width="1300" persistent>
    <v-card>
      <v-card-title>0N Accounts</v-card-title>

      <v-card-text>
        <v-data-table fixed-header hide-default-footer height="600" :headers="headers" :items="getOnReadyAccounts" :loading="getOnReadyAccountsLoading" :items-per-page="-1">
          <template v-slot:item.created_date="{ item }">{{ item.created_date | formatDate | customPlaceholder('-') }}</template>
          <template v-slot:item.sort_code="{ item }">{{ item.sort_code | customPlaceholder('-') }}</template>
          <template v-slot:item.bank_acc_no="{ item }">{{ item.bank_acc_no | customPlaceholder('-') }}</template>
          <template v-slot:item.account_name="{ item }">{{ item.account_name | customPlaceholder('-') }}</template>
          <template v-slot:item.dd_reference="{ item }">{{ item.dd_reference | customPlaceholder('-') }}</template>
          <template v-slot:item.error="{ item }">{{ item.error | customPlaceholder('-') }}</template>
          <template v-slot:item.status="{ item }">{{ item.status | customPlaceholder('-') }}</template>
          <template v-slot:item.live_date="{ item }">{{ item.live_date | formatDate | customPlaceholder('-') }}</template>
          <template v-slot:item.balance="{ item }">{{ item.balance | customPlaceholder('-') }}</template>
          <template v-slot:item.zero_n_error="{ item }">{{ item.zero_n_error | customPlaceholder('-') }}</template>
          <template v-slot:item.actions="{ item }">
            <v-simple-checkbox :value="item.ready" @input="UPDATE_ON_READY_ACCOUNTS_LOCAL(item)" color="primary"></v-simple-checkbox>
          </template>
        </v-data-table>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="d-flex justify-end">
        <v-btn color="primary" :loading="getPostOnNewAttemptsLoading" @click="submit">Ready</v-btn>
        <v-btn color="primary" :disabled="getPostOnNewAttemptsLoading" outlined @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  props: ['open'],

  data() {
    return {
      headers: [
        { text: 'Created Date', sortable: false, value: 'created_date' },
        { text: 'Sort Code', sortable: false, value: 'sort_code' },
        { text: 'Bank Account Number', sortable: false, value: 'bank_acc_no' },
        { text: 'Account Name', sortable: false, value: 'account_name' },
        { text: 'DD Reference', sortable: false, value: 'dd_reference' },
        { text: 'Error', sortable: false, value: 'error' },
        { text: 'Status', sortable: false, value: 'status' },
        { text: 'Live Date', sortable: false, value: 'live_date', width: '150px' },
        { text: 'Balance', sortable: false, value: 'balance' },
        { text: '0N Attempt Error', sortable: false, value: 'zero_n_error' },
        { text: 'Ready?', sortable: false, value: 'actions' },
      ],
    }
  },

  computed: {
    ...mapGetters('ledger/OnReady', ['getOnReadyAccounts', 'getOnReadyAccountInReady', 'getOnReadyAccountsLoading', 'getOnReadyAccountsError']),
    ...mapGetters('ledger/OnDashboard', ['getPostOnNewAttemptsLoading', 'getPostOnNewAttemptsError']),
    ...mapGetters("ledger", ["hasUserGotRoles"]),
  },

  watch: {
    open: {
      immediate: false,
      handler() {
        if (this.open) {
          this.fetchOnReadyAccounts();
        }
      }
    }
  },

  methods: {
    ...mapActions('ledger/OnReady', ['fetchOnReadyAccounts', 'postOnNewAttempts']),
    ...mapActions('ledger/OnDashboard', ['fetchOnAttempts', 'postOnNewAttempts']),
    ...mapActions('alerts', ['setAlert']),
    ...mapMutations('ledger/OnReady', ['UPDATE_ON_READY_ACCOUNTS_LOCAL', 'RESET_ON_READY_STORE']),

    async submit() {
      if(this.hasUserGotRoles(['can-generate-0N-submission-report'])) {
        await this.postOnNewAttempts({ accounts: this.getOnReadyAccountInReady });
        await this.fetchOnAttempts();

        if(!this.getPostOnNewAttemptsError) {
          this.close();
        }
      } else {
        this.setAlert({ type: 'error', message: `You do not have permission to carry out this action` })
      }
    },

    close() {
      this.RESET_ON_READY_STORE();
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>

</style>